import { ListOrgFunctionMembersRequestSchema, ListOrgFunctionMembersResponseSchema } from './list-org-function-members.schema';
/**
 * List OrgFunction Members Endpoint Contract
 *
 * Retrieves the derived member list of a OrgFunction: the users who link to it via
 * mainRole or secondaryRoles, deduped by user id. The lead is the responsible
 * person, not a member.
 */ export const listOrgFunctionMembersContract = {
    method: 'GET',
    path: '/api/v2/org-function/:id/members',
    description: 'Retrieve the derived member list of a OrgFunction',
    requestSchema: ListOrgFunctionMembersRequestSchema,
    responseSchema: ListOrgFunctionMembersResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'OrgFunction not found'
        }
    }
};

//# sourceMappingURL=list-org-function-members.contract.js.map